import React from "react";

const companyList = props => {
  const workExperience = props.workExperience;

  const clickItem = event => {
    props.onCompanyClick(event);
  };

  return workExperience ? (
    <div className="d-flex flex-column pr-3">
      {workExperience.map((work, index) => {
        return (
          <p
            onClick={clickItem}
            key={index}
            id={work.companyName}
            className={`mb-2 employer-box ${props.companyName === work.companyName ? "active" : ""
              }`}
          >
            {work.companyName}
          </p>
        );
      })}
    </div>
  ) : null;
};

export default companyList;
